<template>
    <AdditionalDescriptionEdit 
        :entity-type="BUSINESS_TYPE.GROCER"
        :entity-id="+$route.params.id"
        :category-id="+$route.params.category_id"/>
</template>

<script>
    import AdditionalDescriptionEdit from '@/components/additional-description/AdditionalDescriptionEdit';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'GrocerAdditionalDescriptionEdit',

        components: {
            AdditionalDescriptionEdit
        },
  
        data () {
            return {
                BUSINESS_TYPE
            }
        },
    
        computed: {},

        mounted() {},

        methods: {}
    }
</script>
